// extracted by mini-css-extract-plugin
export var iconContainer = "_bo-0";
export var metricCardsContainer = "_bo-1";